import React from 'react';
import type { User, BusinessUser, DrawerTabType } from '../../../../types/usersDemo';
import { BaseDrawer as Drawer } from '../../../../ui/BaseDrawer';
import { getDrawerWidth } from '../../utils/helpers';
import { Header as DrawerHeader } from './Header';
import { Tabs as DrawerTabs } from './Tabs';
import { ProfileTab } from './ProfileTab';
import { PropertiesTab } from './PropertiesTab';
import { SupportTab } from './SupportTab';
import { ActivityTab } from './ActivityTab';

export interface UserDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  contact: User | BusinessUser | null;
  activeTab: DrawerTabType;
  onTabChange: (tab: DrawerTabType) => void;
  editingRequestId: number | null;
  setEditingRequestId: (id: number | null) => void;
  editingSupportId: number | null;
  setEditingSupportId: (id: number | null) => void;
  setPendingChange: (c: { id: number; newStatus: string; type: 'request' | 'support' }) => void;
  onOpenId: () => void;
}

export const UserDrawer: React.FC<UserDrawerProps> = ({
  isOpen,
  onClose,
  contact,
  activeTab,
  onTabChange,
  editingRequestId,
  setEditingRequestId,
  editingSupportId,
  setEditingSupportId,
  setPendingChange,
  onOpenId,
}) => {
  if (!isOpen || !contact) return null;

  const DrawerComponent = Drawer as any;

  return (
    <DrawerComponent
      role="dialog"
      aria-modal="true"
      isOpen={isOpen}
      onClose={onClose}
      anchor="right"
      size="auto"
      closeable={false}
      overrides={{
        DrawerContainer: {
          style: {
            width: getDrawerWidth(activeTab),
            maxWidth: '90vw',
            backgroundColor: '#ffffff',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
          }
        },
      }}
    >
      <div style={{ height: '100%', overflowY: 'auto' }}>
        <div style={{ padding: '24px' }}>
          <DrawerHeader contact={contact} onClose={onClose} autoFocusClose />
          <DrawerTabs activeTab={activeTab} onChange={onTabChange} />

          {activeTab === 'profile' && (
            <>
              <ProfileTab contact={contact} onOpenId={onOpenId} />
              <PropertiesTab
                contact={contact}
                editingId={editingRequestId}
                setEditingId={setEditingRequestId}
                setPendingChange={setPendingChange as any}
              />
            </>
          )}
          {/* Properties tab removed per request */}
          {activeTab === 'activity' && (
            <ActivityTab contact={contact} />
          )}
          {activeTab === 'support' && (
            <SupportTab
              contact={contact}
              editingId={editingSupportId}
              setEditingId={setEditingSupportId}
              setPendingChange={setPendingChange as any}
            />
          )}
        </div>
      </div>
    </DrawerComponent>
  );
};

export default UserDrawer;


